import { render, staticRenderFns } from "./fechaAltaComponent.vue?vue&type=template&id=5cb118d6&scoped=true"
import script from "./fechaAltaComponent.vue?vue&type=script&lang=js"
export * from "./fechaAltaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb118d6",
  null
  
)

export default component.exports